import React from 'react';

const VLogoIcon = () =>
<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <text x="50%" y="72%" dominantBaseline="middle" textAnchor="middle" fill="white" fontSize="26" fontWeight="800" fontFamily="Arial, sans-serif">V</text>
  </svg>;


const PersonIcon = () =>
<svg width="32" height="32" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
  </svg>;


const StarIcon = ({ filled = true }) =>
<svg width="16" height="16" viewBox="0 0 20 20" fill={filled ? '#f59e0b' : '#e5e7eb'} xmlns="http://www.w3.org/2000/svg">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
  </svg>;


const ProfileCard = () =>
<div
  style={{
    borderRadius: 16,
    boxShadow: '0 8px 40px rgba(0,0,0,0.15)',
    maxWidth: 340,
    margin: '0 auto',
    overflow: 'hidden',
    background: '#fff',
    fontFamily: 'inherit'
  }}>

    {/* Browser address bar */}
    <div
    style={{
      background: '#f1f5f9',
      padding: '8px 12px',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      borderBottom: '1px solid #e2e8f0'
    }}>

      <div style={{ display: 'flex', gap: 5 }}>
        <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#fca5a5' }} />
        <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#fde68a' }} />
        <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#86efac' }} />
      </div>
      <div
      style={{
        flex: 1,
        background: '#fff',
        borderRadius: 6,
        padding: '4px 10px',
        fontSize: 11,
        color: '#64748b',
        border: '1px solid #e2e8f0',
        fontFamily: 'monospace',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}>

        volaptic.com/p/marco-ferretti
      </div>
    </div>

    {/* Gradient top bar */}
    <div
    style={{
      height: 80,
      background: 'linear-gradient(135deg, #104d98 0%, #32b3e5 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>

      <VLogoIcon />
    </div>

    {/* Card body */}
    <div style={{ padding: '0 20px 20px 20px' }}>
      {/* Avatar */}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: -32, marginBottom: 12 }}>
        <div
        style={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          background: '#104d98',
          border: '3px solid #fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}>

          <PersonIcon />
        </div>
      </div>

      {/* Name */}
      <p style={{ textAlign: 'center', fontWeight: 700, fontSize: 18, color: '#0a2540', margin: '0 0 8px 0' }}>
        Marco Ferretti
      </p>

      {/* Profession badge */}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
        <span
        style={{
          background: '#eff6ff',
          color: '#104d98',
          fontSize: 12,
          fontWeight: 600,
          padding: '4px 10px',
          borderRadius: 20,
          border: '1px solid #bfdbfe'
        }}>

          ⚡ Elettricista certificato
        </span>
      </div>

      {/* Star rating */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4, marginBottom: 12 }}>
        {[1, 2, 3, 4, 5]?.map((i) =>
      <StarIcon key={i} filled={true} />
      )}
        <span style={{ fontSize: 13, fontWeight: 700, color: '#0a2540', marginLeft: 4 }}>4.9</span>
        <span style={{ fontSize: 12, color: '#64748b' }}>(12 recensioni)</span>
      </div>

      {/* Bio */}
      <p style={{ fontSize: 13, color: '#64748b', textAlign: 'center', lineHeight: 1.5, margin: '0 0 14px 0' }}>
        10 anni di esperienza nell'impiantistica civile e industriale a Milano e provincia.
      </p>

      {/* Service tags */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, justifyContent: 'center', marginBottom: 16 }}>
        {['Impianti civili', 'Messa a norma', 'Certificazione']?.map((tag) =>
      <span
        key={tag}
        style={{
          background: '#104d98',
          color: '#fff',
          fontSize: 11,
          fontWeight: 600,
          padding: '4px 10px',
          borderRadius: 20
        }}>

            {tag}
          </span>
      )}
      </div>

      {/* CTA button inside card */}
      <button
      style={{
        width: '100%',
        background: '#104d98',
        color: '#fff',
        border: 'none',
        borderRadius: 8,
        padding: '12px 0',
        fontSize: 14,
        fontWeight: 700,
        cursor: 'pointer'
      }}>

        Richiedi un preventivo →
      </button>
    </div>
  </div>;


const BenefitRow = ({ icon, text }) =>
<div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
    <span style={{ fontSize: 22, lineHeight: 1 }}>{icon}</span>
    <span style={{ fontSize: 16, fontWeight: 500, color: '#0a2540' }}>{text}</span>
  </div>;


export default function ProProfileShowcaseSection() {
  return (
    <section style={{ background: '#f8fafc', padding: '80px 0' }}>
      <div
        style={{
          maxWidth: 1100,
          margin: '0 auto',
          padding: '0 24px',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 64,
          alignItems: 'center'
        }}
        className="pro-showcase-grid">

        {/* LEFT: Craftsman image */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img
            src="/assets/images/italian_craftsman_smartphone_profile.png"
            alt="Artigiano italiano sorridente che mostra il suo profilo professionale sullo smartphone"
            style={{
              width: '100%',
              maxWidth: 420,
              borderRadius: 20,
              boxShadow: '0 16px 60px rgba(0,0,0,0.18)',
              objectFit: 'cover',
              display: 'block'
            }} />

        </div>

        {/* RIGHT: Text and benefits */}
        <div>
          {/* Small label */}
          <p
            style={{
              fontSize: 14,
              color: '#104d98',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              marginBottom: 12
            }}>

            Per i professionisti
          </p>

          {/* Main headline */}
          <h2
            style={{
              fontSize: 40,
              fontWeight: 800,
              color: '#013776',
              lineHeight: 1.2,
              margin: '0 0 16px 0'
            }}
            className="pro-showcase-headline">

            La tua pagina personale,<br />in 30 secondi.
          </h2>

          {/* Subheadline */}
          <p
            style={{
              fontSize: 18,
              color: '#64748b',
              lineHeight: 1.6,
              margin: '0 0 28px 0'
            }}>Volaptic crea una pagina professionale solo per te ottimizzata per Google, potrai condividere il link su whatsapp o sui social per ricevere nuove richieste.


          </p>

          {/* Benefit rows */}
          <div style={{ marginBottom: 28 }}>
            <BenefitRow icon="🔗" text="Avrai un link condivisibile" />
            <BenefitRow icon="⭐" text="Recensioni visibili anche su google" />
            <BenefitRow icon="🚀" text="Nuove richieste senza alcuna pubblicità" />
          </div>

          {/* CTA button */}
          <a
            href="/signup-form"
            style={{
              display: 'inline-block',
              background: '#104d98',
              color: '#fff',
              borderRadius: 10,
              padding: '16px 32px',
              fontSize: 17,
              fontWeight: 700,
              textDecoration: 'none',
              cursor: 'pointer'
            }}
            className="pro-showcase-cta">

            Iscriviti ora
          </a>

          {/* Small disclaimer */}
          <p style={{ fontSize: 12, color: '#94a3b8', marginTop: 12 }}>
            Le prime 10 risposte sono gratuite.
          </p>
        </div>
      </div>

      {/* Responsive styles */}
      <style>{`
        @media (max-width: 768px) {
          .pro-showcase-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
          .pro-showcase-headline {
            font-size: 28px !important;
          }
          .pro-showcase-cta {
            display: block !important;
            text-align: center !important;
          }
        }
      `}</style>
    </section>);

}